import { render, staticRenderFns } from "./DefaultPaymentComponent.vue?vue&type=template&id=8249afaa&"
import script from "./DefaultPaymentComponent.vue?vue&type=script&lang=ts&"
export * from "./DefaultPaymentComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports